export const TYPE_LIST = [
	{ name: 'deprecated', isDefault: false },
	{ name: 'primary', isDefault: true },
	{ name: 'info', isDefault: false },
	{ name: 'success', isDefault: false },
	{ name: 'warning', isDefault: false },
	{ name: 'danger', isDefault: false },
	{ name: 'forbid', isDefault: false },
];

export const SIZE_LIST = [
	{ name: 'xs', displayName: 'x-small', isDefault: false },
	{ name: 'sm', displayName: 'small', isDefault: false },
	{ name: 'md', displayName: 'medium', isDefault: true },
	{ name: 'lg', displayName: 'large', isDefault: false },
	{ name: 'xl', displayName: 'x-large', isDefault: false },
];



// WEBPACK FOOTER //
// ./src/utils/enum.js